import { computed, markRaw } from "vue"
import type { Attr, BoundingRect, CartData, Color, CustomableImage, CustomAreas, CustomizedImage, CustomSpu, RawCustomizedImage, SimpleSku, SimpleSpu } from "./api/interface/mirrorinterface"

/**
 * 从AltImages里查找匹配当前颜色的备用图片
 *
 * @param color
 * @param customableImage
 * @returns
 */
export const findCustomableImage = (color: Color, customableImage: CustomableImage) => {
  if (color && customableImage.altImages && customableImage.altImages.length >= 0) {
    const altImage = customableImage.altImages.find(i => {
      return i.attrs?.find(attr => {
        return attr.spuAttr.attribute.key === 'color'
          && convertColor(attr.value || attr.object_value)?.value === color.value
      })
    })
    if (altImage && altImage.alt_image) {
      return altImage.alt_image
    }
  }
  return customableImage.image
}
export const convertColor = (strColor: any): Color | undefined => {
  if (typeof strColor !== 'string') {
    return strColor
  }

  try {
    return JSON.parse(strColor)
  } catch (e) {
    return { name: '', value: strColor }
  }
}

export class EditingImage {
  json: any
  image: CustomizedImage
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fabric: any
  canvasDom?: fabric.Canvas | null | object
  constructor(image: CustomizedImage) {
    this.image = image
    this.fabric = null
    this.canvasDom = null
  }

  onReady = (value?: fabric.Canvas) => {
    this.canvasDom = markRaw(value as fabric.Canvas)
  };
}

export const templateBasicParameters = (image: string, color: string, width: number, height: number, cornerSize: number = 5) => {
  return Object.assign({}, { image, color, width, height, cornerSize })
}

export const convertCustomSpuToSimpleSpu = (customSpu: CustomSpu): SimpleSpu => {
  const colors: Array<Color> = []
  let sizes: Array<string> = []
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const skus: SimpleSku[] = []
  customSpu.customSkus.forEach((item) => {
    const sku: SimpleSku = {
      key: 0,
      color: undefined,
      size: '',
      code: '',
      customCode: 0,
      id: 0
    }
    sku.key = item.id
    sku.customCode = item.id
    sku.code = item.code
    item.sku.attrs.forEach((arr) => {
      if (arr.attribute.key === 'color') {
        const c = convertColor(arr.value || arr.object_value)
        sku.color = c
        item.color = c
        if (c && !colors.find(a => c.value === a.value)) {
          colors.push(c)
        }
      }
      if (arr.attribute.key === 'size') {
        sizes.push(arr.value)
        sku.size = arr.value
        item.size = arr.value
      }
    })
    skus.push(sku)
  })
  sizes = [...new Set(sizes)]
  return {
    colors,
    sizes,
    customSkus: skus,
  }
}

export const convertToCustomizedImage = (image: RawCustomizedImage): CustomizedImage => {
  const o = Object.assign({
    customized_image: image.customized_image,
    price: image.price
  }, image.customableImage, image.customized_areas) as unknown as CustomizedImage
  return o
}

export const assignOriginalCustomizedData = computed(() => (item: any) => {
  return Object.assign({},
    { ...(item.custom_areas || {}) },
    { scale: (item.customable_image_scale || item.custom_areas.scale) },
    item.boundingRect || {})
})
